export const LOOSE_EMAIL_REGX = /^.+@(.+\.)+.+$/
